
/**
 * 
 * @param {String} query 
 * @param {Function} on_match 
 * @param {Function} on_unmatch 
 */
 function match_media(query, on_match, on_unmatch){
    on_match = on_match || function(){};
    on_unmatch = on_unmatch || function(){};

    const mql = window.matchMedia(query);
    mql.addEventListener("change", (event)=>{
        if(event.matches){
            on_match(query);
        }else{
            on_unmatch(query);
        }
    })


    setTimeout(()=>{
        if(mql.matches){
            on_match(query);
        }else{
            on_unmatch(query);
        }
    }, 20)
}

function get_current_media(query, on_match, on_unmatch){
    on_match = on_match || function(){};
    on_unmatch = on_unmatch || function(){};
    const mql = window.matchMedia(query);
    setTimeout(()=>{
        if(mql.matches){
            on_match(query);
        }else{
            on_unmatch(query);
        }
    }, 0)
}

export {match_media, get_current_media}